import { useSnackbarStore } from '~/stores/snackbar'

export default defineNuxtPlugin(() => {
  function setSnack({ callingMn, snack }: { callingMn: string; snack: any }) {
    // eslint-disable-next-line no-console
    console.debug(
      `${callingMn} --> [plugins/setSnack.js] setSnack | Setting snack to:`,
      snack
    )
    useSnackbarStore().set(snack)
  }
  return { provide: { setSnack } }
})
